import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectRace, selectAge, selectShowInvalids } from '@store/order/selectors';
import { setRace, setAge } from '@store/order/slice';
import TextField from '@components/text-field/TextField';
import NumberField from '@components/text-field/NumberField';
import DimensionsSection from '@pages/order-cat/animal-info/DimensionsSection';
import CharacterSection from '@pages/order-cat/animal-info/CharacterSection';
import { invalidFormValue } from '@components/utils';



const AnimalInfo = () => {
	const { t } = useTranslation('forms');

	const race = useSelector(selectRace);
	const age = useSelector(selectAge);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateRace = (value: string | null) => dispatch(setRace(value));
	const updateAge = (value: number | null) => dispatch(setAge(value));

	return (
		<div className='animal-info-section cat-animal-info-section'>

			<DimensionsSection />

			<div className='race-section'>
				<TextField
					label={t('inputLabels.race')}
					required={true}
					maxLength={50}
					value={race ? race : undefined}
					onChange={(value: string) =>
						!value && value.length === 0 ? updateRace(null) : updateRace(value)}
					errorMessage={showInvalids && invalidFormValue(race) ? t('validation.requiredField') : undefined} />
			</div>

			<div className='age-section'>
				<NumberField
					label={t('inputLabels.age')}
					required={true}
					rounded={true}
					value={age}
					maxNumber={100}
					onChange={updateAge}
					errorMessage={showInvalids && invalidFormValue(age) ? t('validation.requiredField') : undefined} />
			</div>

			<CharacterSection />

		</div>
	);
};

export default AnimalInfo;